// Single source of truth for the "become a customer" link shown to demo
// visitors (header Sign Up button + persona picker banner).
//
// Production builds bake ROOT_DOMAIN in via dotenv (e.g. ambunet.co.uk), so
// the canonical URL is https://signup.<ROOT_DOMAIN> — the same derivation
// App.js and the CRM use for cross-subdomain links. Local dev has no
// ROOT_DOMAIN, so fall back to swapping the current host's first label for
// "signup" (demo.localhost:4053 -> signup.localhost:4053, bare localhost ->
// signup.localhost) — App.js routes to <SignUp /> purely on that hostname
// prefix, so the link keeps working in dev.
export const getSignupUrl = () => {
  if (process.env.ROOT_DOMAIN) {
    return `https://signup.${process.env.ROOT_DOMAIN}`
  }

  const { protocol, hostname, port } = window.location
  const parentDomain = hostname.includes('.')
    ? hostname.split('.').slice(1).join('.')
    : hostname

  return `${protocol}//signup.${parentDomain}${port ? `:${port}` : ''}`
}

export const openSignup = () => {
  window.open(getSignupUrl(), '_blank', 'noopener,noreferrer')
}
